import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
// StrictMode is disabled to avoid "Cannot delete property '__reactFiber$...'" when
// embedding Web Components that use React internally (e.g. supplier-dashboard,
// union-dashboard). StrictMode's double mount/unmount causes React to detach from
// DOM nodes that custom elements may have made non-extensible.
root.render(<App />);

